import React from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";
import { useTheme } from "@mui/material/styles";
import NoDataText from "../NoDataText/NoDataText";

const DonutChart = ({
	data,
	onChartClick = () => {},
	seriesName,
	radius,
}) => {
	const theme = useTheme();

	// Check if the data is empty
	if (!data || data.length === 0) {
		return <NoDataText />;
	}

	// Safe click handler
	const onDonutClick = (params) => {
		if (typeof onChartClick === "function") {
			onChartClick(params);
		}
	};

	// Prepare the chart options
	const option = {
		tooltip: {
			trigger: "item",
		},
		legend: {
			orient: "vertical",
			left: "center",
			bottom: "bottom",
		},
		series: [
			{
				name: seriesName,
				type: "pie",
				radius: radius,
				avoidLabelOverlap: false,
				itemStyle: {
					// borderRadius: 10,
				},
				label: {
					show: false,
					position: "bottom",
				},
				emphasis: {
					itemStyle: {
						shadowBlur: 10,
						shadowOffsetX: 0,
						shadowColor: "rgba(0, 0, 0, 0.5)",
					},
				},
				data: data,
			},
		],
	};

	return (
		<ReactECharts
			option={option}
			style={{ height: "100%", width: "100%" }}
			onEvents={{ click: onDonutClick }}
		/>
	);
};

export default DonutChart;